<template>
	<div class="c-dashboard__wrap" v-if="currentDate"
        :data-component-name="$options.name"
	>
        <!-- <ResourceView
            :currentDate="currentDate"
            @set-current-date="$emit('set-current-date', $event)"
            @set-current-view="$emit('set-current-view', $event)"
            @jump-to-project-week="jumpToProjectWeek($event)"
        /> -->
	</div>
</template>

<script>
    // import ResourceView from '@/components/dashboard/ResourceView';

	export default {
	// 	name: "Resources",
    //     components: {
    //         ResourceView
	// 	},
	// 	props: {
	// 		currentDate: {
    //             type: String,
    //             default: null
    //         },
	// 	},
		data(){
			return {
				currentDate: null
			}
		},
	// 	methods: {
	// 	},
	// 	mounted(){
	// 	},
    //     // apollo: {
	// 	// }
	}
</script>
<style lang="scss" scoped>
	@import "@/scss/views/Dashboard.scss";
</style>

<style lang="scss">
	.schedule{
		background-color: white;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 60px;
	}
</style>